<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">إضافة عقار</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/properties">العقارات</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">إضافة عقار</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center">
          <div class="col-12">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <mainLoader v-if="copyLoading" />
            <PropertiesForm
              v-if="!copyLoading"
              cardTitle="إضافة عقار"
              :copyFromData="copyFromData"
            />
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import PropertiesForm from './form.vue';

export default {
  name: 'PropertiesCreate',
  components: {
    PropertiesForm
  },
  data() {
    return {
      copyLoading: false,
      hasError: false,
      message: '',
      errorNumber: 0,
      copyFromData: null,
    };
  },
  methods: {
    fetchCopyData(id) {
      this.copyLoading = true;
      this.hasError = false;
      this.$http.get(`/api/admin/properties/retrieve/${id}`).then(({ data }) => {
        this.copyFromData = data.property;
        this.copyLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.copyLoading = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
  },
  created() {
    const copyId = this.$route.query.copyId;
    if (copyId) {
      this.fetchCopyData(copyId);
    }
  },
}
</script>
